import moment, { Moment } from 'moment';
import Organizer from '../inkind-organizers/Organizer';

export interface IUserPageAPIModel {
  id: number;
  slug: string;
  routeId: string;
  title: string;
  description: string;
  name: string;
  address: string;
  address2: string;
  zip: string;
  recipientEmail: string;
  contactEmail: string;
  city: string;
  state: number;
  location: string;
  imgSrc: string;
  thumb_small: string;
  thumb_medium: string;
  cover_src: string;
  cover_src_retina: string;
  notes: string;
  isCalendar: boolean;
  isNewCalendar: boolean;
  flowers: boolean;
  visitors: boolean;
  meals: boolean;
  help: boolean;
  wishList: boolean;
  amazonWishlist: boolean;
  coverColourIndex: number;
  amazonWishlistRequest: {
    amazonWishlistUrl_WithRef: string;
  };
  payPal: boolean;
  phoneCalls: boolean;
  CTA: boolean;
  GlobalCTA: boolean;
  owner: Organizer;
  organizers: Organizer[];
  subscribers: any;
  relatedObjects: {
    situations: [];
    categories: [];
    recipients: [];
    tags: [];
    relatedArticles: [];
    relatedProducts: [];
    featuredProducts: [];
    helpfulProducts: [];
    situationFilters: null;
    products: {
      products: [];
      tags: any;
      eop: boolean;
    };
  };
  isOwner: boolean;
  isOrganiser: boolean;
  isFollowing: boolean;
  isPublic: boolean;
  isHideFromPublic: boolean;
  feedbackPoint: number;
  phoneCallRequest: {
    name: string;
    IsTextsOk: boolean;
  };
  financialContributions: {
    paypalEmail: string;
    goFundMeUrl: string;
  };
  situations: any;
  created: string;
  modified: string;
  ownerData: any;
  organiserData: any;
}

export default class InkindPage {
  private routeId: string;
  private id: number;
  private imageSrc: string;
  private title: string;
  private location: string;
  private slug: string;
  private organizer: boolean;
  private created: moment.Moment;
  private owner: Organizer;
  private organizers: Organizer[];
  private payPal: boolean;

  private CTA: boolean;
  private GlobalCTA: boolean;
  private amazonWishlist: boolean;
  private amazonWishlistRequest: {
    amazonWishlistUrl_WithRef: string;
  };
  private financialContributions: {
    paypalEmail: string;
    goFundMeUrl: string;
  };
  private flowers: boolean;
  private isCalendar: boolean;
  private phoneCallRequest: {
    name: string;
    IsTextsOk: boolean;
  };
  private phoneCalls: boolean;
  private visitors: boolean;
  private wishList: boolean;

  static fromAPI({
    routeId,
    id,
    imgSrc,
    title,
    location,
    slug,
    isOrganiser: organizer,
    created,
    organizers,
    owner,
    payPal,

    CTA,
    GlobalCTA,
    amazonWishlist,
    amazonWishlistRequest,
    financialContributions,
    flowers,
    isCalendar,
    phoneCallRequest,
    phoneCalls,
    visitors,
    wishList,
  }: IUserPageAPIModel) {
    const p = new InkindPage();

    p.routeId = routeId;
    p.id = id;
    p.imageSrc = imgSrc;
    p.title = title;
    p.location = location;
    p.slug = slug;
    p.organizer = organizer;
    p.created = moment(created);
    p.organizers = organizers;
    p.owner = owner;
    p.payPal = payPal;

    p.CTA = CTA;
    p.GlobalCTA = GlobalCTA;
    p.amazonWishlist = amazonWishlist;
    p.amazonWishlistRequest = amazonWishlistRequest;
    p.financialContributions = financialContributions;
    p.flowers = flowers;
    p.isCalendar = isCalendar;
    p.phoneCallRequest = phoneCallRequest;
    p.phoneCalls = phoneCalls;
    p.visitors = visitors;
    p.wishList = wishList;

    return p;
  }

  public getCreateDate(): moment.Moment {
    return this.created;
  }

  public getRouteId(): string {
    return this.routeId;
  }

  public getId(): number {
    return this.id;
  }

  public getImageURL(): string {
    return this.imageSrc;
  }

  public getLink(): string {
    return `/inkinds/${this.routeId}/${this.slug}`;
  }

  public getSlug(): string {
    return this.slug;
  }

  public getTitle(): string {
    return this.title;
  }

  public getLocation(): string {
    return this.location;
  }

  public isOrganizer(): boolean {
    return this.organizer;
  }

  public getOrganizers(): Organizer[] {
    return this.organizers;
  }

  public getOwner(): Organizer {
    return this.owner;
  }

  public acceptsCrowdfunding(): boolean {
    return this.payPal;
  }

  public getCTA(): boolean {
    return this.CTA;
  }

  public getGlobalCTA(): boolean {
    return this.GlobalCTA;
  }

  public getAmazonWishlist(): boolean {
    return this.amazonWishlist;
  }

  public getAmazonWishlistRequest() {
    return this.amazonWishlistRequest;
  }

  public getFinancialContributions() {
    return this.financialContributions;
  }

  public getFlowers() {
    return this.flowers;
  }

  public getIsCalendar() {
    return this.isCalendar;
  }

  public getPhoneCallRequest() {
    return this.phoneCallRequest;
  }

  public getPhoneCalls() {
    return this.phoneCalls;
  }

  public getVisitors() {
    return this.visitors;
  }

  public getWishList() {
    return this.wishList;
  }
}
